<script setup>
import { computed } from 'vue';
const props = defineProps(['pages', 'currentPage']);
const maxVisiblePages = 5;
const pageAmount = computed(() => {
	let correctCurrentPage = props.currentPage - 1;

	if (maxVisiblePages >= props.pages) {
		return [...Array(props.pages).keys()];
	}

	if (props.currentPage + maxVisiblePages > props.pages) {
		return [...Array(props.pages).keys()].splice(props.pages - maxVisiblePages, maxVisiblePages);
	}

	return [...Array(props.pages).keys()].splice(correctCurrentPage, maxVisiblePages);
});
</script>

<template>
	<div class="c-pagination-wrapper">
		<button
			@click="$emit('changePage', -1)"
			:disabled="currentPage == 1"
			class="c-pagination-button c-pagination-button--back"
		>
			<svg class="icon icon-icon_arrow"><use xlink:href="#icon-icon_arrow"></use></svg>
		</button>
		<ul class="c-pagination">
			<template v-if="props.currentPage + maxVisiblePages >= props.pages && maxVisiblePages <= props.pages">
				<li>
					<button @click="$emit('setPage', 1)">1</button>
				</li>
				<li>...</li>
			</template>
			<li v-for="page in pageAmount" :class="{ active: page + 1 == currentPage }">
				<button @click="$emit('setPage', page + 1)">
					{{ page + 1 }}
				</button>
			</li>
			<template v-if="props.currentPage + maxVisiblePages < props.pages && maxVisiblePages <= props.pages">
				<li>...</li>
				<li v-if="props.currentPage + maxVisiblePages < props.pages && maxVisiblePages <= props.pages">
					<button @click="$emit('setPage', pages)">
						{{ pages }}
					</button>
				</li>
			</template>
		</ul>
		<button @click="$emit('changePage', +1)" :disabled="currentPage == pages" class="c-pagination-button">
			<svg class="icon icon-icon_arrow"><use xlink:href="#icon-icon_arrow"></use></svg>
		</button>
	</div>
</template>
